import React from "react";

export default function SQLServer_LOWER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_LOWER</h1>
      <p>This is the SQLServer_LOWER component generated from the SQL JSON.</p>
    </div>
  );
}
